import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

import * as styles from './DropdownMenuContainer.css';

interface DropdownMenuContainerProps {
  children: ReactNode;
}

export const DropdownMenuContainer = ({
  children,
}: DropdownMenuContainerProps) => (
  <Box position="relative">
    <Box className={styles.backdrop}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flexEnd"
        paddingX="medium"
      >
        {children}
      </Box>
    </Box>
  </Box>
);
